export const mezzoMonitoringTitles = {
  pendant: 'Add Monitored Mezzo Pendant',
  detector: 'Add Monitored Mezzo Detector',
}

export const fieldNames = {
  pendant: 'pendant',
  detector: 'detector',
}
